export class FieldValidationError extends Error {
    message;
    data;
    
    constructor(message, data){
        super(message)
        this.data = data
    }
}